// Colour values of the tuning (docs/ROADMAP.md D34): sRGB "#RRGGBB" as the page shows it, uppercase. A ColourHex can only
// come from parseColourHex, so every colour a knob holds is well formed and compares by ===.

declare const colourHexBrand: unique symbol
export type ColourHex = string & { readonly [colourHexBrand]: true }

const COLOUR_HEX = /^#[0-9A-Fa-f]{6}$/
const CHANNEL_MAX = 255
const HEX_RADIX = 16
const RED_SHIFT = 16
const GREEN_SHIFT = 8
const CHANNEL_MASK = 0xff

/** A "#RRGGBB" colour, normalised to uppercase; null for anything else (no shorthand, no alpha). */
export function parseColourHex(text: string): ColourHex | null {
  return COLOUR_HEX.test(text) ? (text.toUpperCase() as ColourHex) : null
}

/** The colour's sRGB channels, each 0–1. */
export function srgbChannels(colour: ColourHex): readonly [number, number, number] {
  const packed = Number.parseInt(colour.slice(1), HEX_RADIX)
  return [((packed >> RED_SHIFT) & CHANNEL_MASK) / CHANNEL_MAX, ((packed >> GREEN_SHIFT) & CHANNEL_MASK) / CHANNEL_MAX, (packed & CHANNEL_MASK) / CHANNEL_MAX]
}
